import { baseTheme } from '@src/theme';
import styled from 'styled-components';

export const StyledFormLabelContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledLabel = styled.label`
    font-size: 16px;
    color: ${(props) =>
        props.theme?.colors?.secondary?.main?.text ||
        baseTheme.colors.secondary.main.text};
`;

export const StyledRequiredMark = styled.span`
    font-size: 16px;
    color: ${(props) =>
        props.theme?.colors?.error?.main?.text ||
        baseTheme.colors.error.main.text};
`;

export const StyledPlaceholder = styled.span`
    /* Empty placeholder for layout purposes */
`;
